// Dit webbläsaren skickas när ägaren betalar eller öppnar kundportalen: Stripes
// egna sidor (ADR 0075). Testerna byter ut funktionen och fångar adressen.
export const stripeSida = {
  oppna: (url: string) => {
    window.location.assign(url);
  },
};
